<template>
	<b-button
		data-augmented-ui="both tl-clip br-clip"
		class="rb-button"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot />
	</b-button>
</template>

<script>
	export default {
		name: 'RbButton',
		data: () => ({}),
	}
</script>

<style lang="scss" scoped>
	.rb-button {
		background: none !important;
		border: none !important;
		box-shadow: none !important;

		padding: 5px 20px;
		transition: --aug-inlay-bg .3s;

		&.btn-primary {
			--aug-border-bg: #{linear-gradient(to bottom, rgba($primary, .3), rgba($primary, .4))};
			--aug-inlay-bg: #{rgba($primary, .3)};

			&:hover, &:focus {
				--aug-border-bg: #{linear-gradient(to bottom, rgba($primary, .5), rgba($primary, .6))};
				--aug-inlay-bg: #{rgba($primary, .5)};
			}

			&[disabled] {
				pointer-events: none;
			}
		}

		&.btn-danger {
			--aug-border-bg: #{linear-gradient(to bottom, rgba($danger, .3), rgba(darken($danger, 10), .4))};
			--aug-inlay-bg: #{rgba($danger, .3)};

			&:hover, &:focus {
				--aug-border-bg: #{linear-gradient(to bottom, rgba($danger, .5), rgba(darken($danger, 10), .6))};
				--aug-inlay-bg: #{rgba($danger, .5)};
			}

			&[disabled] {
				pointer-events: none;
			}
		}
	}
</style>
